import { MeshPhysicalMaterial, type MeshStandardMaterial } from 'three'

interface FabricMaterialProfile {
    roughness: number
    normalStrength: number
    specularIntensity: number
    sheen: number
    sheenRoughness: number
    anisotropy: number
    environmentIntensity: number
}

// Visual starting points from the Scrunchie landing-page closeups. Roughness
// multiplies the existing GLB roughness map; texture tiling stays product-owned.
const FABRIC_MATERIAL_PROFILES:Readonly<Record<string, FabricMaterialProfile>> = {
    'matte-crepe': {
        roughness: 0.85,
        normalStrength: 1.15,
        specularIntensity: 0.85,
        sheen: 0.16,
        sheenRoughness: 1,
        anisotropy: 0,
        environmentIntensity: 0.8,
    },
    'silk-charmeuse': {
        roughness: 0.98,
        normalStrength: 0.85,
        specularIntensity: 0.6,
        sheen: 0.7,
        sheenRoughness: 0.65,
        anisotropy: 0.3,
        environmentIntensity: 0.8,
    },
}

export const hasFabricMaterialProfile = (fabric:string | undefined):fabric is string => (
    fabric !== undefined
    && Object.prototype.hasOwnProperty.call(FABRIC_MATERIAL_PROFILES, fabric)
)

export const applyFabricMaterialProfile = (
    material:MeshStandardMaterial,
    fabric:string | undefined,
):void => {
    if(!hasFabricMaterialProfile(fabric)) return
    const profile = FABRIC_MATERIAL_PROFILES[fabric]

    material.metalness = 0
    material.roughness = profile.roughness
    material.normalScale.setScalar(profile.normalStrength)
    material.envMapIntensity = profile.environmentIntensity

    if(material instanceof MeshPhysicalMaterial) {
        material.specularIntensity = profile.specularIntensity
        material.sheen = profile.sheen
        material.sheenColor.set('#ffffff')
        // Fiber scattering follows the printed color instead of laying a
        // uniform white sheen over dark and saturated artwork.
        material.sheenColorMap = material.map
        material.sheenRoughness = profile.sheenRoughness
        material.anisotropy = profile.anisotropy
        material.anisotropyRotation = 0
    }
}
